/**
 * Fetch wrapper for ordering API calls.
 * Includes credentials for cookie auth and X-Kamari-Mode header.
 */
export function orderingFetch(url: string, options?: RequestInit): Promise<Response> {
  return fetch(url, {
    ...options,
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
      'X-Kamari-Mode': 'enabled',
      ...options?.headers,
    },
  })
}
